import { render, staticRenderFns } from "./unionGoodsManage.vue?vue&type=template&id=4f60a9ee&scoped=true&"
import script from "./unionGoodsManage.vue?vue&type=script&lang=js&"
export * from "./unionGoodsManage.vue?vue&type=script&lang=js&"
import style0 from "./unionGoodsManage.vue?vue&type=style&index=0&id=4f60a9ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60a9ee",
  null
  
)

component.options.__file = "unionGoodsManage.vue"
export default component.exports